"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sbLeftColumnReducer = void 0;

var _actions = require("./actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getDefaultState = function getDefaultState() {
  return {
    isCollapsed: false,
    isHidden: false
  };
};

var sbLeftColumnReducer = function sbLeftColumnReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isCollapsed = state.get ? state.get('isCollapsed') : state === null || state === void 0 ? void 0 : state.isCollapsed;
  var type = action.type,
      payload = action.payload;

  if (type === _actions.TOGGLE_LEFT_COLUMN) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isCollapsed: !isCollapsed
    });
  }

  if (type === _actions.HIDE_LEFT_PANEL) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isHidden: payload.isHidden
    });
  }

  return state;
};

exports.sbLeftColumnReducer = sbLeftColumnReducer;
//# sourceMappingURL=sb-left-column-reducer.js.map